// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--VT1L6","icon":"_7a3fb80146--icon--_5KHV","description":"_7a3fb80146--description--Yc3wj"};